export function getString(val: string | null | undefined): string {
  if (val === null || val === undefined) return "";
  return val;
}
